import { SocialHeartIcon, SocialInstagramIcon, SocialLinkedinIcon, SocialPinterestIcon, SocialRetweetIcon, SocialRssIcon, SocialSlackIcon, SocialTwitterIcon, SocialXIcon, SocialGoogleIcon, SocialFacebookIcon, SocialGoogleDriveIcon, SocialGoogleplusIcon, SocialYoutubeIcon, SocialYoutubeplayIcon, SocialXingIcon } from 'foundations-assets';
export const SOCIAL_MAP = {
  facebook: {
    icon: SocialFacebookIcon,
    color: 'do-not-use-facebook'
  },
  google: {
    icon: SocialGoogleIcon,
    color: 'do-not-use-google'
  },
  googledrive: {
    icon: SocialGoogleDriveIcon,
    color: 'do-not-use-google'
  },
  googleplus: {
    icon: SocialGoogleplusIcon,
    color: 'do-not-use-google'
  },
  heart: {
    icon: SocialHeartIcon,
    color: 'do-not-use-candy-apple'
  },
  instagram: {
    icon: SocialInstagramIcon,
    color: 'do-not-use-instagram'
  },
  linkedin: {
    icon: SocialLinkedinIcon,
    color: 'do-not-use-linkedin'
  },
  pinterest: {
    icon: SocialPinterestIcon,
    color: 'do-not-use-pinterest'
  },
  retweet: {
    icon: SocialRetweetIcon,
    color: 'do-not-use-twitter'
  },
  rss: {
    icon: SocialRssIcon,
    color: 'do-not-use-rss'
  },
  slack: {
    icon: SocialSlackIcon,
    color: 'do-not-use-facebook'
  },
  twitter: {
    icon: SocialTwitterIcon,
    color: 'do-not-use-twitter'
  },
  x: {
    icon: SocialXIcon,
    color: 'do-not-use-x'
  },
  xing: {
    icon: SocialXingIcon,
    color: 'do-not-use-xing'
  },
  youtube: {
    icon: SocialYoutubeIcon,
    color: 'do-not-use-youtube'
  },
  youtubeplay: {
    icon: SocialYoutubeplayIcon,
    color: 'do-not-use-youtube'
  }
};
export const AVATAR_SIZES = {
  xxs: 16,
  xs: 24,
  sm: 32,
  md: 48,
  lg: 72,
  xl: 108,
  responsive: 'responsive'
};
export const AVATAR_LIST_SIZES_MARGIN_OFFSET = {
  xxs: '-50',
  xs: '-100',
  sm: '-100',
  md: '-200',
  lg: '-200',
  xl: '-400',
  responsive: '0'
};
export const AVATAR_TYPES = {
  company: 'COMPANIES',
  companyId: 'COMPANIES',
  contact: 'CONTACT',
  domain: 'COMPANIES',
  email: 'CONTACT',
  emails: 'CONTACT',
  enrichmentDomain: 'COMPANIES',
  enrichmentEmail: 'CONTACT',
  hubSpotUserEmail: 'CONTACT',
  hubSpotUserEmails: 'CONTACT',
  productId: 'PRODUCT',
  vid: 'CONTACT',
  ticket: 'TICKET',
  deal: 'DEAL'
};
export const AVATAR_TYPE_ICONS = {
  COMPANIES: 'companies',
  CONTACT: 'contacts',
  PRODUCT: 'product',
  TICKET: 'ticket',
  DEAL: 'deals'
};
export const RETINA_MULTIPLIER = 2;
export const API_KNOWN_KEY_MAPPINGS = {
  contact: 'knownContacts',
  company: 'knownCompanies'
};
export const API_KNOWN_VALUE_MAPPINGS = {
  contact: {
    primaryIdentifier: 'vid',
    secondaryIdentifier: 'email'
  },
  company: {
    primaryIdentifier: 'companyId',
    secondaryIdentifier: 'domain'
  }
};
export const API_IDENTIFIER_MAPPINGS = {
  contact: 'vids',
  company: 'companyIds',
  vids: 'vids',
  vid: 'vids',
  companyId: 'companyIds',
  email: 'emails',
  domain: 'domains',
  enrichmentEmail: 'emails',
  enrichmentDomain: 'domains',
  hubSpotUserEmails: 'hubSpotUserEmails',
  hubSpotUserEmail: 'hubSpotUserEmails',
  product: 'productIds',
  productId: 'productIds'
};
export const DEFAULT_MAX_UPLOAD_SIZE_MB = 4;
export const OBJECT_TYPE_TO_ENDPOINT_MAPPINGS = {
  contact: 'contacts/vid',
  vid: 'contacts/vid',
  company: 'companies/companyId',
  companyId: 'companies/companyId',
  product: 'products/productId',
  productId: 'products/productId'
};
export const OBJECT_TYPES_THAT_REQUIRE_PORTAL_ID = ['contact', 'vid', 'company', 'companyId', 'product', 'productId'];
export const AVATAR_SOURCE_TYPES = {
  DEFAULT_COMPANY_AVATAR: 'default-company-avatar',
  DEFAULT_CONTACT_AVATAR: 'default-contact-avatar',
  KNOWN_SRC: 'known-src'
};
export const MULTI_AVATAR_DEFAULT_BORDER_COLOR = 'border-core-on-fill-default';
export const MULTI_AVATAR_DEFAULT_BORDER_WIDTH = '200';
export const MULTI_AVATAR_DEFAULT_BORDER_STYLE = 'solid';
export const AVATAR_BACKGROUND_COLOR = 'icon-core-subtle';